// extracted by mini-css-extract-plugin
export default {"icon":"icon__1Bunl","iconWithTextContainer":"iconWithTextContainer__1Xl5m","image":"image__2P72x","link":"link__rOni_","primaryText":"primaryText__2ADgP"};